import httpService from "./httpService"

export const getStagesDataApi = (stage: any) => {
    return httpService.post("blog/stage", stage)
}